import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import './SectionLoading.css';

export default function SectionLoading({
  label = 'Loading',
  className = '',
  size = 'md',
  showCaption = true,
}) {
  const wrapClass = ['section-loading', className].filter(Boolean).join(' ');

  return (
    <div className={wrapClass}>
      <LoadingSpinner label={label} size={size} />
      {showCaption && label ? <p className="section-loading-caption">{label}</p> : null}
    </div>
  );
}
